export default __webpack_public_path__ + "static/media/wp-logo.6973c63c.png";